import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Application"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 13.5H4.5C3.67157 13.5 3 12.8284 3 12V4.5C3 3.67157 3.67157 3 4.5 3H12C12.8284 3 13.5 3.67157 13.5 4.5V12C13.5 12.8284 12.8284 13.5 12 13.5ZM4.5 4.5V12H12V4.5H4.5ZM19.5 9V12H16.5V9H19.5ZM19.5 7.5H16.5C15.6716 7.5 15 8.17157 15 9V12C15 12.8284 15.6716 13.5 16.5 13.5H19.5C20.3284 13.5 21 12.8284 21 12V9C21 8.17157 20.3284 7.5 19.5 7.5ZM19.5 16.5V19.5H16.5V16.5H19.5ZM19.5 15H16.5C15.6716 15 15 15.6716 15 16.5V19.5C15 20.3284 15.6716 21 16.5 21H19.5C20.3284 21 21 20.3284 21 19.5V16.5C21 15.6716 20.3284 15 19.5 15ZM12 16.5V19.5H9V16.5H12ZM12 15H9C8.17157 15 7.5 15.6716 7.5 16.5V19.5C7.5 20.3284 8.17157 21 9 21H12C12.8284 21 13.5 20.3284 13.5 19.5V16.5C13.5 15.6716 12.8284 15 12 15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Application.vue"]]);
